export default __webpack_public_path__ + "static/media/sl8.be902128.svg";